module.exports = __webpack_public_path__ + "static/screen1-f91b1393c254fa3ce3a8eb533affb0e6.png";